import { render } from "./BaseNativeSelect.vue?vue&type=template&id=79820530&scoped=true"
import script from "./BaseNativeSelect.vue?vue&type=script&lang=js"
export * from "./BaseNativeSelect.vue?vue&type=script&lang=js"

import "./BaseNativeSelect.vue?vue&type=style&index=0&id=79820530&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-79820530"

export default script